import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=5aa2bf8e&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=js&"
export * from "./IconCheck.vue?vue&type=script&lang=js&"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=5aa2bf8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa2bf8e",
  null
  
)

export default component.exports